(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-artist-leiste"] && !Shopify.designMode) return;
  try {
    
  // Auf Zeigefinger-Geraeten oeffnet der erste Tipp die Beschriftung, der zweite folgt dem
  // Link. Ohne diesen Zwischenschritt spraenge man weg, ohne je gesehen zu haben, wohin.
  // Ohne JavaScript bleibt der Punkt ein gewoehnlicher Link — dann fuehrt schon der erste
  // Tipp zum Ziel, was schlechter, aber nicht kaputt ist.
  (() => {
    const grob = () => matchMedia('(pointer: coarse)').matches;
    const zu = (ausser) => document.querySelectorAll('.nv-hotspot[data-offen]').forEach((a) => {
      if (a !== ausser) a.removeAttribute('data-offen');
    });
    document.addEventListener('click', (e) => {
      const punkt = e.target.closest('.nv-hotspot');
      if (!punkt) { zu(null); return; }
      if (!grob()) return;
      if (punkt.hasAttribute('data-offen')) return;   // zweiter Tipp folgt dem Link
      e.preventDefault();
      zu(punkt);
      punkt.setAttribute('data-offen', '');
      // In den Bildrand zurueckschieben: Umklappen nach links reicht nicht, wenn die
      // Beschriftung breiter ist als der Platz bis zum Rand (gemessen 18.08.: 164 px
      // Beschriftung auf einer 268 px breiten Karte).
      const feld = punkt.closest('.nv-ah__feld');
      const text = punkt.querySelector('.nv-hotspot__text');
      if (!feld || !text) return;
      text.style.removeProperty('translate');
      const f = feld.getBoundingClientRect();
      const r = text.getBoundingClientRect();
      let dx = 0;
      if (r.left < f.left + 8) dx = f.left + 8 - r.left;
      else if (r.right > f.right - 8) dx = f.right - 8 - r.right;
      if (dx) text.style.translate = dx + 'px -50%';
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
